import SashiDo from 'lib/SashiDo';
import React, { Component } from 'react';
import history from 'dashboard/history';
import moment from 'moment';
import SashiDoTable from 'components/SashiDo/SashiDoTable.react';
import { nanoSecondsFormat } from 'lib/helpers';
import stylesButton from 'components/Button/Button.scss';
import StatusIndicator from 'components/StatusIndicator/StatusIndicator.react';

import Tooltip from 'react-autotip';

import styles from './EngineView.scss';

const STATUS_COLOR = {
  new: 'orange',
  pending: 'blue',
  running: 'blue',
  failed: 'red',
  cancelled: 'gray',
  complete: 'green',
  active: 'green',
};

const STATUS_CONTENT = {
  new: 'NEW',
  pending: 'PENDING',
  running: 'RUNNING',
  failed: 'FAILED',
  cancelled: 'CANCELLED',
  complete: 'COMPLETE',
  active: 'ACTIVE',
};

export default class BuildsView extends Component {
  constructor() {
    super();

    this.state = {};
  }

  navigateToLogs(objectId, e) {
    history.push(`/products/apps/${this.props.currentApp.slug}/runtime/builds/${objectId}/log`);
    e.preventDefault();
    e.stopPropagation();
  }

  cancelHandler = async (name, e) => {
    e.preventDefault();
    e.stopPropagation();

    const { appId } = this.props;

    await SashiDo.cancelBuild({
      appId,
      name,
    });

    this.props.refreshGraph();
  }

  handleMoreInfo = async (id, email) => {
    this.setState((prevState) => {
      let currentRow = id;
      if (prevState.currentRow === id) {
        currentRow = null;
      }

      return {
        currentRow,
      };
    });
  };

  renderCols = () => {
    const cols = [
      <colgroup key="builds_colgroup">
        <col width="100" />
        <col width="140" />
        <col width="180" />
        <col />
        <col width="200" />
        <col width="100" />
      </colgroup>,
    ];

    return cols;
  }

  renderHeaders = () => {
    const headers = [
      <thead key="builds_thead">
        <tr>
          <th>#</th>
          <th>Source</th>
          <th>Created At</th>
          <th>Complete In</th>
          <th>
            <div className={styles.builds}>Status</div>
          </th>
          <th>Action</th>
        </tr>
      </thead>,
    ];

    return headers;
  }

  renderRow(item) {
    const phase = (item.phase || '').toLowerCase();

    const duration = nanoSecondsFormat(item.duration);

    const color = STATUS_COLOR[phase];
    const status = STATUS_CONTENT[phase];

    const isSpecialStatus = ['running', 'pending', 'new'].includes(phase);

    const classnames = [];

    if (item.objectId === this.state.currentRow) {
      classnames.push(styles.open);
    }

    const githubURL = `https://github.com/parsegroundapps/pg-app-${this.props.currentApp.serviceName}/commit/${item.trigger.commit}`;

    return (
      <tr key={item.objectId} className={classnames.join(' ')}>
        <td>{item.number}</td>
        <td className={styles.source}>
          {
            item.trigger.source === 'GitHub'
              ?
              <div className={styles.moreInfo} onClick={() => this.handleMoreInfo(item.objectId, item.trigger.author.email)}>
                <span>{item.trigger.source}</span>
              </div>
              : item.trigger.source
          }
          {
            item.objectId === this.state.currentRow
              ?
              <div className={styles.moreInfoBox}>
                <p className={styles.commitMessage}>[<a href={githubURL} target="_blank" rel='noreferrer noopener'>{item.trigger.commit.substr(0, 7)}</a>] - {item.trigger.message}</p>
                <p>
                  Authored by {item.trigger.author.name} ({item.trigger.author.email})
                  </p>
              </div>
              : null
          }
        </td>
        <td>
          <Tooltip
            text={<div>{moment(item.createdAt).format('MMM DD YYYY HH:mm')}</div>}
            tooltipStyles={{
              color: '#fff',
              fontFamily: 'Ubuntu',
              fontSize: 14,
              fontWeigt: 300,
              borderRadius: 4,
              maxWidth: 500,
              width: 140,
              unit: 4,
              lightgrey: '#222933',
              opaqueGrey: '#222933',
            }}>
            <span>{moment(item.createdAt).fromNow()}</span>
          </Tooltip>
        </td>
        <td>
          {duration}
        </td>
        <td>
          <div className={[styles.builds, styles[phase]].join(' ')}>
            <StatusIndicator color={color} status={status} loading={isSpecialStatus} />
            {
              isSpecialStatus
                ?
                <span
                  className={[stylesButton.tableButton, stylesButton.red].join(' ')}
                  onClick={this.cancelHandler.bind(this, item.name)}>
                  Cancel
                  </span>
                : null
            }
          </div>
        </td>
        <td>
          <a
            className={[stylesButton.tableButton].join(' ')}
            href={`/products/apps/${this.props.currentApp.slug}/runtime/builds/${item.objectId}/log`}
            onClick={this.navigateToLogs.bind(this, item.objectId)} >
            View Log
          </a>
        </td>
      </tr>
    );
  }

  render() {
    const { logs } = this.props;

    if (!logs) {
      return null;
    }

    return (
      <div className="box table">
        <SashiDoTable className="hover">
          {this.renderCols()}
          {this.renderHeaders()}
          <tbody>
            {logs.map(row => this.renderRow(row))}
          </tbody>
        </SashiDoTable>
      </div>
    );
  }
}
